// Shared input validation/sanitization — used across every form that
// collects a name/email/phone (registration wizard, Pay It Forward,
// MyPayments dialogs, staff creation). Previously nothing blocked typing a
// digit into a name field anywhere in the app.

// Letters (incl. accented), spaces, hyphens, apostrophes, periods (for
// initials like "J. R.") — strips everything else as the user types, rather
// than only validating on submit, so invalid characters never appear at all.
const NAME_CHARS = /[^\p{L}\s'.-]/gu;

export function sanitizeNameInput(value) {
  return (value || "").replace(NAME_CHARS, "");
}

export function isValidName(value) {
  const v = (value || "").trim();
  return v.length >= 1 && !/[0-9]/.test(v);
}

// Digits, spaces, parens, plus, hyphen — enough to type a US number in any
// common format (e.g. "(555) 123-4567") without over-restricting.
const PHONE_CHARS = /[^\d\s()+-]/g;

export function sanitizePhoneInput(value) {
  return (value || "").replace(PHONE_CHARS, "");
}

export function isValidPhone(value) {
  const digits = (value || "").replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
}

export function isValidEmail(value) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((value || "").trim());
}
